import React from "react";
import useAccountRestriction from "../../hooks/useAccountRestriction";

const RestrictedAccountAlert = ({ className = "" }) => {
  const { isRestricted, restrictionMessage } = useAccountRestriction();

  if (!isRestricted) {
    return null;
  }

  return (
    <div
      className={`rounded-lg border-2 border-red-400 bg-red-50 px-4 py-3 text-red-900 shadow-sm ${className}`}
    >
      <p className="text-sm font-semibold text-red-700">Account Restricted</p>
      <p className="mt-1 text-sm text-red-800">{restrictionMessage}</p>
    </div>
  );
};

export default RestrictedAccountAlert;
